'use strict'
const ApiService = require('../_provider.api');

class GeoLocation extends ApiService {
	constructor(init) {
		super(init);
		return this;
	}
	detect(ip) {
		return this.get({
			url : 'v2/geo_location/detect',
			params : {
				clientIp: ip
			}
		})
	}
}

module.exports = GeoLocation;



// WEBPACK FOOTER //
// providers/providers/GeoLocationProvider.js